import {images} from "../constants";

// export const deviceStatusInactiveTime = {
//     'day': '#de0733',
//     'hour': '#f2a900',
//     'minute': '#7815ac',
// }

export const deviceStatusInactiveText = {
    'day': 'more than day',
    'hour': 'more than hour',
    'minute': 'more than 5 minutes',
}


export const deviceStatusInactiveTimeToText = {
    'day': '> 1 day',
    'hour': '> 1 hour',
    'minute': '> 5 minute',
}

export const deviceStatusInactiveIcons = {
    'day': images.deviceInactiveDay,
    'hour': images.deviceInactiveHour,
    'minute': images.deviceInactiveMinute,
    'default': images.deviceActive,
    'total': images.logo,
};